import { useContext, useState, useEffect } from 'react';

import { BottomLink } from './components/bottomLink';
import { MessageLink } from './components/messageLink';

import SvgIcon from '@/components/SvgIcon';
import { LayoutContext } from '@/layouts/baseLayout/provider';

export default function Footer() {
  const { resourceData, websiteSectionList } = useContext(LayoutContext);
  const [year, setYear] = useState('');

  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  const sloganCom = (resourceData?.commonConfigVO?.websiteFooterVOList || []).map((item, index) => (
    <li key={index} className="flex items-center">
      <img src={item.imageUrl || ''} className="rounded-[50%]" alt={item.title} height={50} width={50} />
      <div className="ml-[10px]">
        <p className="mb-[6px] text-[18px] text-[#333]">{item.title}</p>
        {item.copyWriting.split(/\n|\/n/).map((val, index) => (
          <p className="text-[12px] text-[#666]" key={index}>
            {val}
          </p>
        ))}
      </div>
    </li>
  ));

  return (
    <footer className="w-[100%] bg-[#ECEDF0]" data-spm="ft" id={'lcsc-footer'}>
      <ul className="mx-auto flex w-[1200px] justify-between border-b border-solid border-[#DEE0E2] px-[50px] py-[20px]">
        {sloganCom}
      </ul>
      <div className="mx-auto w-[1200px] border-b border-solid border-[#DEE0E2] py-[20px]">
        <MessageLink websiteSectionList={websiteSectionList} />
      </div>
      <div className="mx-auto w-[1200px] pb-[30px] pt-[16px]">
        <BottomLink resourceData={resourceData} />
      </div>

      <div className="w-full bg-[#CED1D5]">
        <div className="mx-auto flex h-[40px] w-[1200px] items-center text-[12px] text-[#444]">
          <p>© {year} 深圳市立创电子商务有限公司 版权所有</p>
          <SvgIcon app="common" iconName="beian" className="ml-[19px] mr-[5px] h-[24px] w-[20px]" />
          <a
            rel="nofollow"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402002194"
            target="_blank"
          >
            粤公网安备 44030402002194
          </a>
          <a className="ml-[9px]" rel="nofollow" href="https://beian.miit.gov.cn" target="_blank">
            粤ICP备13005967号
          </a>
          <SvgIcon app="common" iconName="gsj" className="ml-[19px] mr-[5px] h-[24px] w-[20px]" />
          <a
            rel="nofollow"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402002194"
            target="_blank"
          >
            工商网监
          </a>
          <a
            className="ml-[26px]"
            rel="nofollow"
            target="_blank"
            href="https://static.szlcsc.com/doc/isoiec/last/iso_iec_doc.pdf"
          >
            ISO/IEC
          </a>
          <p className="ml-[26px]">|</p>
          <img
            src="https://static.szlcsc.com/ecp/assets/newWeb/footer/gh.png"
            className="w-[20px] h-[20px] ml-[26px] mr-[5px]"
          />
          <a rel="nofollow" target="_blank" href="https://www.szlcsc.com/businessLicence.html">
            营业执照
          </a>
        </div>
      </div>
    </footer>
  );
}
